// import { Navigate, useLocation } from 'react-router-dom';
// import { useFranchiseForm } from './FranchiseFormContext';

import { Navigate, useLocation } from "react-router";
import { useRoForm } from "./RoContext";

const stepOrder = [
    '/personalinformationmanagerhub',
    '/residencyaddmanager',
    '/kycmanagerhub',
    '/bankaccountdetailsmanagerhub',
    '/aggrementdetailsmanager',

];

// const ProtectedStepRoute = ({ element: Element, path }) => {
//     const { completedSteps } = useFranchiseForm();
//     const location = useLocation();
//     const currentIndex = stepOrder.indexOf(path);

//     const isPreviousStepsCompleted = stepOrder
//         .slice(0, currentIndex)
//         .every(step => completedSteps.includes(step));

//     if (!isPreviousStepsCompleted) {
//         return <Navigate to={stepOrder.find(step => !completedSteps.includes(step)) || '/kycverification'} state={{ from: location }} replace />;
//     }

//     return <Element />;
// };



const ProtectedStepRoute = ({ element: Element, path }) => {
    const { completedSteps, setCompletedSteps } = useRoForm();
    const location = useLocation();
    const currentIndex = stepOrder.indexOf(path);

    const isPreviousStepsCompleted = stepOrder
        .slice(0, currentIndex)
        .every(step => completedSteps.includes(step));


    if (!isPreviousStepsCompleted) {
        return <Navigate to={stepOrder.find(step => !completedSteps.includes(step)) || '/personalinformationmanagerhub'} state={{ from: location }} replace />;
    }

    return <Element />;
};

export default ProtectedStepRoute;